export enum PortingOption {
  EarlyTermination = 2,
  Continuation = 3,
}
